<section class="shiksha-team-contribution" [attr.aria-label]="content.ariaLabel">
    <header class="shiksha-team-contribution__header">
        <app-shiksha-dashboard-subtitle-header
            [title]="content.title"
            [subtitle]="content.subtitle"
            [iconName]="uiConfig.titleIconName"
            [iconSize]="uiConfig.titleIconSize"
        />
    </header>

    @if (hasRows()) {
        <div class="shiksha-team-contribution__table">
            <div class="shiksha-team-contribution__table-head">
                <span class="shiksha-team-contribution__head-label">{{ content.rankHeader }}</span>
                <span class="shiksha-team-contribution__head-label">{{
                    content.teamMemberHeader
                }}</span>
                <span
                    class="shiksha-team-contribution__head-label shiksha-team-contribution__head-cell"
                >
                    <span>{{ content.pipelineHeader }}</span>
                    <span class="shiksha-team-contribution__head-info">
                        <span class="shiksha-team-contribution__head-info-badge">{{
                            subtitleHeaderUi.infoBadgeChar
                        }}</span>
                        <span class="shiksha-team-contribution__head-info-text">{{
                            content.pipelineInfo
                        }}</span>
                    </span>
                </span>
                <span
                    class="shiksha-team-contribution__head-label shiksha-team-contribution__head-cell"
                >
                    <span>{{ content.dealWonHeader }}</span>
                    <span class="shiksha-team-contribution__head-info">
                        <span class="shiksha-team-contribution__head-info-badge">{{
                            subtitleHeaderUi.infoBadgeChar
                        }}</span>
                        <span class="shiksha-team-contribution__head-info-text">{{
                            content.dealWonInfo
                        }}</span>
                    </span>
                </span>
                <span
                    class="shiksha-team-contribution__head-contribution shiksha-team-contribution__head-cell"
                >
                    <span>{{ content.contributionHeader }}</span>
                    <span class="shiksha-team-contribution__head-info">
                        <span class="shiksha-team-contribution__head-info-badge">{{
                            subtitleHeaderUi.infoBadgeChar
                        }}</span>
                        <span class="shiksha-team-contribution__head-info-text">{{
                            content.contributionInfo
                        }}</span>
                    </span>
                </span>
            </div>

            <div class="shiksha-team-contribution__table-body">
                @for (row of contributionRows(); track row.rank + '-' + row.name + '-' + $index) {
                    <article class="shiksha-team-contribution__table-row">
                        <span class="shiksha-team-contribution__rank" [class]="row.rankToneClass">{{
                            row.rank === 1 ? '🏆' : row.rank
                        }}</span>

                        <div class="shiksha-team-contribution__member">
                            <span class="shiksha-team-contribution__avatar" aria-hidden="true">
                                {{ row.initials }}
                            </span>
                            <span class="shiksha-team-contribution__name">{{ row.name }}</span>
                        </div>

                        <span
                            class="shiksha-team-contribution__pipeline"
                            [attr.data-label]="content.pipelineHeader"
                            >{{ row.pipeline }}</span
                        >
                        <span
                            class="shiksha-team-contribution__closed-revenue"
                            [attr.data-label]="content.dealWonHeader"
                            >{{ row.closedRevenue }}</span
                        >

                        <span
                            class="shiksha-team-contribution__contribution"
                            [attr.data-label]="content.contributionHeader"
                        >
                            <span class="shiksha-team-contribution__plain-value"
                                >{{ row.contributionPercent }}{{ content.percentSymbol }}</span
                            >
                        </span>
                        <span class="shiksha-team-contribution__win-rate-hidden" aria-hidden="true">
                            {{ row.winRate }}
                        </span>
                    </article>
                }
            </div>
        </div>
    } @else {
        <div class="shiksha-team-contribution__empty">
            <p class="shiksha-team-contribution__empty-title">{{ content.emptyTitle }}</p>
            <p class="shiksha-team-contribution__empty-text">{{ content.emptyMessage }}</p>
        </div>
    }
</section>
